import FAQSection, { type FAQItem } from "@/components/FAQSection";

const educationFaqs: FAQItem[] = [
  {
    q: "Зачем компании обучать сотрудников работе с ИИ?",
    a: "Корпоративное обучение ИИ помогает перевести интерес к нейросетям в рабочие сценарии. Сотрудники учатся использовать ИИ в документах, аналитике, коммуникациях и повторяющихся задачах, а компания получает более подготовленную команду для дальнейших AI-пилотов и внедрений.",
  },
  {
    q: "С чего начать корпоративное обучение ИИ?",
    a: "Начинать стоит с задач бизнеса и уровня подготовки сотрудников. До программы важно определить, кто будет учиться, какие процессы занимают больше всего времени и какие реальные рабочие задачи участники смогут разобрать на обучении.",
  },
  {
    q: "Чему нужно обучать сотрудников по ИИ в первую очередь?",
    a: "Базовые навыки работы с ИИ включают постановку задач модели, работу с контекстом, проверку ответов, анализ документов и данных, безопасность и создание повторяемых рабочих сценариев. После этого можно переходить к скилам, помощникам и ИИ-агентам.",
  },
  {
    q: "Как выбрать программу обучения ИИ для сотрудников?",
    a: "Хорошая программа корпоративного обучения ИИ должна учитывать реальные задачи компании и роли участников. Практика на собственных процессах обычно даёт больше пользы, чем общий обзор нейросетей и сервисов.",
  },
  {
    q: "Как обучить сотрудников применять ИИ в реальной работе?",
    a: "Лучший материал для обучения ИИ уже находится внутри компании. Участник берёт повторяющуюся рабочую задачу, разбирает её вместе с тренером, собирает рабочий сценарий и проверяет результат на собственных материалах или обезличенных примерах.",
  },
  {
    q: "Подходит ли одно обучение ИИ для сотрудников с разным уровнем подготовки?",
    a: "Да, если программа строится вокруг задач каждого участника. В WMT AI смешанные группы работают со своими кейсами, поэтому новичок может освоить базовые принципы, а более опытный сотрудник перейти к скилам, помощникам и автоматизации процесса.",
  },
  {
    q: "Нужно ли отдельно обучать руководителей работе с ИИ?",
    a: "Руководителям нужен отдельный фокус на принятии решений, анализе процессов, постановке задач, проверке результатов и поиске ИИ-инициатив. Подготовленный руководитель лучше понимает возможности технологии и может поддерживать изменения внутри своей команды.",
  },
  {
    q: "Сколько должно длиться корпоративное обучение ИИ?",
    a: "Формат зависит от задачи. Для базового практического старта может использоваться интенсив, а для работы с полноценным бизнес-процессом нужен более длинный цикл с практикой между встречами, проверкой качества и расчётом экономики решения.",
  },
  {
    q: "Что сотрудник должен получить после обучения ИИ?",
    a: "Результатом обучения должны стать конкретные рабочие артефакты: настроенная ИИ-среда, улучшенные запросы, разобранный процесс, собственный скил, помощник или прототип решения. Участник должен понимать, как продолжать использовать и развивать результат после программы.",
  },
  {
    q: "Как измерить эффективность обучения ИИ сотрудников?",
    a: "Эффективность корпоративного обучения ИИ можно измерять через использование инструментов в реальных задачах, скорость выполнения операций, качество результата, количество созданных сценариев и переход инициатив в пилоты. Для конкретных решений полезно делать исходный замер до обучения.",
  },
  {
    q: "Почему сотрудники после обучения перестают пользоваться ИИ?",
    a: "Чаще всего практика не закрепляется, если обучение было оторвано от рабочих задач или сотрудник не понимает, где применять новые навыки. Поэтому обучение лучше связывать с реальными процессами, готовыми сценариями, поддержкой и понятным следующим шагом.",
  },
  {
    q: "Как обучать сотрудников безопасной работе с нейросетями?",
    a: "Безопасность должна входить в программу обучения ИИ. Сотрудникам важно понимать, какие данные можно передавать модели, как обезличивать материалы, где нужен контроль человека и какие полномочия можно выдавать ИИ-помощнику.",
  },
  {
    q: "Можно ли на обучении ИИ работать с реальными корпоративными данными?",
    a: "Можно, если это разрешено внутренними правилами компании и согласовано с требованиями безопасности. Для чувствительных данных используются обезличивание, ограничения доступа или подготовленные учебные материалы.",
  },
  {
    q: "Можно ли после обучения сотрудников перейти к внедрению ИИ в бизнес-процессы?",
    a: "Да. Обучение может стать первым этапом ИИ-трансформации: сотрудники находят рабочие сценарии, проверяют их на своих задачах, после чего наиболее перспективные инициативы переходят в пилоты, разработку и масштабирование.",
  },
  {
    q: "Чем корпоративное обучение ИИ отличается от обычного курса по нейросетям?",
    a: "Корпоративное обучение строится вокруг задач конкретной компании, её процессов, данных и ролей сотрудников. Основная ценность появляется, когда участники создают рабочие сценарии и применяют их после программы в ежедневной работе.",
  },
];

const EducationFAQSection = () => <FAQSection items={educationFaqs} sectionId="education-faq" />;

export default EducationFAQSection;
